import { Theme } from '@mui/material/styles';
import { sliderClasses } from '@mui/material/Slider';

// ----------------------------------------------------------------------

export function slider(theme: Theme) {
  const lightMode = theme.palette.mode === 'light';

  return {
    MuiSlider: {
      styleOverrides: {
        root: {
          [`&.${sliderClasses.disabled}`]: {
            color: theme.palette.action.disabledBackground,
            [`& .${sliderClasses.track}`]: {
              backgroundColor: theme.palette.action.disabledBackground,
            },
            [`& .${sliderClasses.rail}`]: {
              backgroundColor: theme.palette.action.disabledBackground,
            },
            [`& .${sliderClasses.thumb}`]: {
              backgroundColor: theme.palette.action.disabledBackground,
            }
          },
        },
        track: {
          backgroundColor: theme.palette.eliga_AF9.main,
        },
        rail: {
          backgroundColor: theme.palette.eliga_EDA.main
        },
        thumb: {
          width: '10px',
          height: '10px',
          backgroundColor: theme.palette.eliga_AF9.main
        },
        markLabel: {
          fontSize: 13,
          color: theme.palette.text.disabled,
        },
        valueLabel: {
          borderRadius: 8,
          backgroundColor: theme.palette.grey[lightMode ? 800 : 700],
        },
      },
    },
  };
}
